const linkResolver = (doc) => {
  // URL for a page type
  if (doc.type === 'pages') {
    return `/${doc.uid}`
  }

  // Backup for all other types
  return '/'
}

export default linkResolver
